import React, { useEffect, useState } from 'react';

const DiscountOffer = (props) => {
    const [ isWorking, setIsWorking ] = useState(false);
    const [ shouldAdvance, setShouldAdvance ] = useState(false);
    const [ redemptionError, setRedemptionError ] = useState(false);

    useEffect(() => {
        if (shouldAdvance) {
            props.advance(4);
        }
    }, [shouldAdvance]);

    useEffect(() => {
        let couponErrors = props.getApiErrors(['SUB_APPLY_COUPON']);

        if (isWorking) {
            setIsWorking(false);
        }

        if (couponErrors.length) {
            let error = couponErrors[0],
                keys = [];
            if (error.errors.validation !== undefined) {
                keys = Object.keys(error.errors.validation);
                setRedemptionError(error.errors.validation[keys[0]]);
            } else if (error.errors.recurly !== undefined) {
                keys = Object.keys(error.errors.recurly);
                setRedemptionError(error.errors.recurly[keys[0]]);
            }

            props.deleteApiError(['SUB_APPLY_COUPON']);
        }

    }, [props.app.messages]);

    let discountDesc = '',
        discountAmt = '',
        buttonText = 'Claim offer',
        constants = props.app.config.constants;

    if (props.user.plan.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
        discountDesc = "Get half off for 3 months!";
        discountAmt = "50% off";
    } else if (props.user.plan.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
        discountDesc = "Get 30% off your next year!"
        discountAmt = "30% off";
    } else {
        // if the user doesn't have a monthly or annual sub, we probably can't discount them
       setShouldAdvance(true);
    }

    const claimOffer = (e) => {
        let couponCode = '';
        if (props.user.plan.planTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
            couponCode = 'boost_monthly';
        } else if (props.user.plan.planTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
            couponCode = 'boost_annual';
        }
        setIsWorking(true);
        setRedemptionError('');
        props.applyCoupon({
            plan: props.user.plan.planCode,
            code: couponCode
        });
    }

    if (isWorking) {
        buttonText = (
            <span><i className="fa fa-spinner fa-spin"></i></span>
        );
    }

    return (
        <div className="discount-offer-wrapper">
            <div className="discount-offer">
                <div className="discount-title">
                    Before you cancel, we may have a better solution for you.
                </div>
                {redemptionError ? (
                    <div className="discount-error">
                        {redemptionError}
                    </div>
                ) : null}
                <div className="discount-display">
                    <div className="discount-detail">
                        <div className="pitch">
                            {discountDesc}
                        </div>
                        <div className="emphasis">
                            {discountAmt}
                        </div>
                    </div>
                    <div className="sense-of-urgency">
                        Limited time offer
                    </div>
                </div>
                <div className="claim-button" role="button" onClick={(isWorking) ? null : claimOffer}>
                    {buttonText}
                </div>
                {!isWorking ? (
                    <div className="cancel-advance">
                        <div className="no-thanks-link" onClick={(e) => {
                            props.advance(4)
                        }}>
                            No thanks
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default DiscountOffer;
